import React from "react";
import { useDispatch, useSelector } from "react-redux";
import TableCell from "./TableCell";
import { Tooltip } from "@mui/material";
import { managementCompanyFields } from "../../../config/mgmtDataConfig";
import {
  setSelectedManagement,
  selectedSelectedManagement,
} from "../../../../../../../redux/mgmtCo/selectedManagementSlice";
import { ResizableBox } from "react-resizable";
import "react-resizable/css/styles.css";
import useColumnResizing from "../../../../../../../hooks/useColumnResizing";

const MgmtTable = ({
  handleOpenViewModal,
  expanded,
  sortField,
  order,
  handleSort,
}) => {
  const dispatch = useDispatch();
  const companies = useSelector((state) => state.management.companies);
  const selectedCompany = useSelector(selectedSelectedManagement);

  const handleRowClick = (company) => {
    if (
      selectedCompany &&
      selectedCompany.managementId === company.managementId
    ) {
      dispatch(setSelectedManagement(null));
    } else {
      dispatch(setSelectedManagement(company));
    }
  };

  const handleRowDoubleClick = (company) => {
    dispatch(setSelectedManagement(company));
    handleOpenViewModal(company);
  };

  const handleIdClick = (company) => {
    dispatch(setSelectedManagement(company));
    handleOpenViewModal(company);
  };

  const {
    headerRefs,
    headerWidths,
    tableWidths,
    handleResize,
    handleResizeStop,
  } = useColumnResizing(managementCompanyFields);

  return (
    <div className="overflow-x-auto">
      <div className="min-w-max mx-auto">
        <table className="table-auto">
          <thead className="sticky top-0 z-10 bg-gray-50">
            <tr>
              {managementCompanyFields.map((field) => (
                <th
                  key={field.key}
                  className="relative pl-4 py-2 text-left text-sss-blue-sel hover:bg-cyan-100"
                >
                  <ResizableBox
                    width={headerWidths[field.key]}
                    height={20}
                    axis="x"
                    onResize={handleResize(field.key)}
                    onResizeStop={handleResizeStop(field.key)}
                    resizeHandles={["e"]}
                    handle={
                      <span
                        className="group absolute -right-4 top-0 bottom-0 w-4 cursor-col-resize"
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <span className="absolute right-0 top-0 bottom-0 w-1 group-hover:bg-sss-blue-sel" />
                      </span>
                    }
                  >
                    <Tooltip title={field.tooltip || field.header}>
                      <span
                        ref={(el) => (headerRefs.current[field.key] = el)}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSort(field.key);
                        }}
                        className="block w-full whitespace-nowrap overflow-hidden text-ellipsis select-none"
                      >
                        {field.label}{" "}
                        {sortField === field.key &&
                          (order === "asc" ? "▲" : "▼")}
                      </span>
                    </Tooltip>
                  </ResizableBox>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="text-gray-700">
            {companies.map((company) => {
              const companyId = Number(company.managementId);
              const isSelected =
                selectedCompany &&
                Number(selectedCompany.managementId) === companyId;
              return (
                <tr
                  key={companyId}
                  onClick={() => handleRowClick(company)}
                  onDoubleClick={() => handleRowDoubleClick(company)}
                  className={`border-t cursor-pointer ${
                    isSelected ? "bg-cyan-100" : "bg-transparent"
                  } ${!isSelected ? "hover:bg-white hover:shadow-lg" : ""}`}
                >
                  {managementCompanyFields.map((field) => (
                    <TableCell
                      key={field.key}
                      field={field}
                      managementCompany={company}
                      handleIdClick={handleIdClick}
                      width={tableWidths[field.key]}
                    />
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MgmtTable;
